module.exports = __webpack_public_path__ + "img/file_delete.d8616567.png";